import CRXLogo from '@/assets/branding/communityrx/CommRXLogo_Circle.png';

const colors = {
  // Brand colors
  brand_primary: '#FF6600',
  brand_primary_hover: '#C45308', // −10 L, −8 S
  brand_primary_highlight: '#fab006', // +23 L, +7 S
  brand_primary_mid: '#FF7E29', // +8 L,  +2 S
  brand_primary_dark: '#7E3302', // −25 L, −3 S (clamped)
  brand_secondary: '#A7540C', // hue +4°, −15 L, −13 S
  brand_accent_start: '#FF7A1A',
  brand_accent_end: '#F2B705',
  brand_accent_light_start: '#FFF1E8',
  brand_accent_light_end: '#FFF3D6',
  brand_complementary_accent: 'rgb(20,161,255)',
  brand_auth_gradient_mid: '#A7540C',
  brand_auth_gradient_end: '#7E3302',
  brand_auth_warp_mid: '#FF7E29',
};

export default {
  name: 'All is Well',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CRXLogo,
  colors,
};
